import { useParsePopupMessage } from '../use-parse-popup-message';
import useInitDataOverlay from './use-init-data-overlay';
import useInitSubscribeOverlay from './use-init-subscribe-overlay';

function useInitOverlay() {
  useParsePopupMessage();
  useInitDataOverlay();
  useInitSubscribeOverlay();
}

export default useInitOverlay;
